import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { actionCreators } from "../redux/sagas/funnelChart";

export function UpdateBtns({ showFutureAppointment }) {
  const dispatch = useDispatch();

  const filtersDirty = useSelector((state) => state.laser.filtersDirty);
  const startFrom = useSelector((state) => state.laser.selectedFilters.startFrom.id);

  const showAppointmentsToggle = showFutureAppointment && startFrom == "leads";

  return filtersDirty ? (
    <div
      className={
        (startFrom == "shows" || startFrom == "enrollments") && !showAppointmentsToggle
          ? "hide-loose-conversions"
          : ""
      }
    >
      <button
        className="submit"
        onClick={() => {
          dispatch(actionCreators.updateChart());
        }}
      >
        Update
      </button>

      <button className="submit reset" onClick={() => dispatch(actionCreators.resetData())}>
        Reset
      </button>
    </div>
  ) : null;
}
